let LineupsQuantity = {
    SET_LINEUPS_QUANTITY: 'SET_LINEUPS_QUANTITY',
};

export default LineupsQuantity;
